// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"734":"2a9fa136","845":"f02e26b2"}[chunkId] + ".chunk.js";
};